import localforage from 'localforage'

// Default instance for document-related persistence
localforage.config({
  name: 'deepguide-docs',
})

// Dedicated instance for chat-related persistence
export const chatLocalforage = localforage.createInstance({
  name: 'deepguide-chat',
})

export default localforage
